import React, { Component } from 'react';

import { Table, Modal } from 'antd';
// import echarts from 'echarts';

import components from '../../../components';
import SelectInput from '../../../components/selectinput';

import services from '../../../services';
import layouts from '../../../layouts';

import utils from '../../../utils';


class Query extends Component {
    constructor(props) {
        super(props);

        const session = JSON.parse(sessionStorage.session);

        const defaultKeywords = Object.assign({
            courseName: '',
            employeeId: '',
            realName: '',
            bgTermId: session.account.termId,
            bgTermName: session.account.termName,
            endTermId: session.account.termId,
            endTermName: session.account.termName,
        }, utils.getKeywords());

        this.state = {
            loading: false,
            keywords: defaultKeywords,
            data: [],
            option: {},
            domain: defaultKeywords,
            toggble: false,
            attachment: false,
            pid: '',
            courseData: [],
            employeeData: [],
            list: [],
            header: [],
            dataSource: []

        };

        this.domain = defaultKeywords;

        services.targetAnalysisByTarget.onSelect([]);
    }

    componentDidMount() {
        this.querySearch();
    }

    querySearch() {
        this.setState({
            loading: true
        });
        const domain = Object.assign({}, this.state.keywords, this.domain);
        return services.home.homePageByTeacher.querySearchAnalysis(domain)
            .then(response => {
                if (response.code === 200) {
                    const data = response.data;

                    this.setState({
                        loading: false
                    });

                    const columnsData = [{
                        dataIndex: 'orgName',
                        title: '部门名称'
                    }, {
                        dataIndex: 'realName',
                        title: '教师姓名'
                    }, {
                        dataIndex: 'courseName',
                        title: '课程名称'
                    }, {
                        dataIndex: 'targetName',
                        title: '指标名称'
                    }];

                    const header = columnsData.filter(item => {
                        return domain[item.dataIndex] ? true : false
                    });

                    header.push({
                        dataIndex: 'childTarget',
                        title: '对象名称'
                    }, {
                        dataIndex: 'score',
                        title: '分数'
                    });

                    const dataSource = (data || []).map(row => {
                        var dataline = {};
                        header.forEach(item => {
                            if (item.dataIndex === 'childTarget') {
                                dataline['childTarget'] = row.category;
                            } else if (item.dataIndex === 'score') {
                                dataline['score'] = row.value;
                            } else {
                                dataline[item.dataIndex] = domain[item.dataIndex]
                            }
                        });

                        return dataline;
                    });


                    const dataSourceCharts = data.map(item => {
                        return {
                            name: item.category,
                            category: item.category,
                            count: +item.value,
                            value: item.value,
                            percentage: item.percentage
                        }
                    });

                    this.setState({
                        header,
                        dataSource,
                        dataSourceCharts
                    });

                } else {
                    this.setState({
                        loading: false
                    });
                }

            }).catch(error => {
                this.setState({
                    loading: false
                });
            });
    }

    handleSearchSubmit() {
        this.setState({
            keywords: Object.assign({}, this.state.keywords, this.domain, { v: Date.now(), pageNum: 1 }),
            toggble: false
        });

        this.querySearch();
    }

    handleChange(data) {
        this.domain = Object.assign({}, this.domain, data);
        this.setState({
            domain: this.domain,
            keywords: this.domain,
        });

        utils.setKeywords(this.domain);
    }

    toggleHandle() {
        this.setState({
            toggble: !this.state.toggble
        });
    }

    // componentWillReceiveProps(nextProps) {
    //     const itemId = nextProps.params.itemId;
    //     if (itemId && this.itemId !== itemId) {
    //         this.setState({
    //             keywords: {
    //                 itemId,
    //                 v: Date.now()
    //             }
    //         });

    //         this.itemId = itemId;
    //     }

    // }

    attathmentCancel() {
        this.setState({
            attachment: false
        });
    }

    attachmentHandle(row) {
        this.setState({
            attachment: true,
            pid: row.id
        });
    }

    querySearchByCourse(value) {
        var params = {
            courseName: value,
            orgId: this.state.keywords.orgId,
            employeeId: this.state.keywords.employeeId,
            limitFlag: true
        };

        return services.course.querySearchByName(params)
            .then((data) => {
                return data.map(item => {
                    return {
                        value: item.value,
                        key: item.value,
                        label: item.label
                    }
                }).slice(0, 500);
            }).then(courseData => {
                this.setState({
                    courseData
                })
            });
    }

    querySearchByEmployee(value) {
        var params = {
            realName: value,
            orgId: this.domain.orgId,
            limitFlag: true
        };

        return services.employee.querySearchByName(params)
            .then((data) => {
                return data.map(item => {
                    return {
                        value: item.value,
                        key: item.value,
                        label: item.label
                    }
                }).slice(0, 500);
            }).then(employeeData => {
                this.setState({
                    employeeData
                })
            });
    }

    render() {
        const dataSource = this.state.dataSource;
        const size = dataSource.length;
        return (
            <layouts.ViewPort>
                <layouts.Search classNames='2' onSubmit={this.handleSearchSubmit.bind(this)}>
                    <div className={this.state.toggble ? "root-search-wrapper search-toggle-open" : "root-search-wrapper"}>
                        <div className="search-item" >
                            <div style={{float:'left'}}>
                                <h3>教师分数与本部门以及全校对比</h3>
                            </div>
                            <div style={{textAlign:'right',marginRight:'5px'}}>

                                <components.evals.Name value={this.state.keywords.targetName} style={{ width: 160 }} label="评价指标" name="targetId" handleChange={this.handleChange.bind(this)} />
                                <SelectInput
                                    name="courseName"
                                    value={this.state.keywords.courseName}
                                    style={{ width: 160 }}
                                    search={true}
                                    onChange={(data) => {
                                        this.handleChange({
                                            courseId: data.key,
                                            courseName: data.label
                                        })
                                    }}
                                    onSearch={(value) => {
                                        this.querySearchByCourse(value);
                                    }}
                                    onFocus={(target) => {
                                        this.querySearchByCourse('');
                                    }}
                                    label="课程"
                                    data={this.state.courseData}
                                />
                                <components.Submit loading={this.state.loading} icon="search"></components.Submit>
                            </div>
                        </div>
                    </div>
                </layouts.Search>
                <div className="root-file root-file-new">
                    <div class="root-graph-view">
                        <div className="root-chart-line" style={{height: 350,width:'100%'}}>
                            <div style={{width:'70%',float:'left'}}>
                            {
                                this.state.dataSourceCharts ? <components.GroupCharts
                                    initChartsType={'bar'}
                                    dataSource={this.state.dataSourceCharts}
                                    title={{text: ``, subtext: ``, x: 'center'}}
                                /> : ""
                            }
                            </div>
                            <div style={{width:'30%',float:'left'}}>
                            {
                                size ? <Table bordered={true} columns={this.state.header} dataSource={this.state.dataSource} pagination={false} size="small" /> : ''
                            }
                            </div>
                        </div>
                    </div>
                </div>
            </layouts.ViewPort>
        )
    }
}

export default Query;